import categoryService from "../services/categoryService";
import subCategoriesServices from "../services/subCategoriesServices";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILED = "GET_CATEGORIES_FAILED";
export const GET_SUBCATEGORIES_SUCCESS = "GET_SUBCATEGORIES_SUCCESS";
export const GET_SUBCATEGORIES_FAIL = "GET_SUBCATEGORIES_FAIL";

const fetchCategoriesSuccess = (categories) => ({
  type: FETCH_CATEGORIES_SUCCESS,
  payload: categories,
});

// fetch brands
export const fetchBrands = (brands) => {
  return (dispatch) => {
    dispatch(fetchCategoriesSuccess(brands));
  };
};
//////////////////

export const getCategories = () => {
  return (dispatch) => {
    categoryService
      .getAllCategory()
      .then((res) => {
        dispatch({
          type: GET_CATEGORIES_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_CATEGORIES_FAILED,
          payload: err,
        });
      });
  };
};
export const getSubCategories = () => {
  return (dispatch) => {
    subCategoriesServices
      .getAllSubCategories()
      .then((res) => {
        dispatch({
          type: GET_SUBCATEGORIES_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_SUBCATEGORIES_FAIL,
          payload: err,
        });
      });
  };
};
